<template>
   <div>
        <div class="q-display-1 q-mb-md">
            <span class="q-headline text-weight-light">{{ $t('sales_history') }}</span>
        </div>

        <q-table
            :data="historys"
            :columns="columns_history"
            :pagination.sync="server_pagination"
            @request="request"
            :loading="loading"
            :filter="filter"
            row-key="name"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[5,10,50,100]"
            binary-state-sort
            >

            <template slot="top" slot-scope="props" :props="props">
                <q-search v-model="filter" icon="far fa-search" :placeholder="$t('search')" :debounce="500" />

                <div class="col" />

                <span class="text-positive capitalize text-weight-bold q-mr-md">
                    <q-icon name="fal fa-check" />
                    {{ calculatePercentage(qty_user_sale_audited) }}% {{ $t('audited') }}
                </span>

                <span class="text-negative capitalize text-weight-bold q-mr-md">
                    <q-icon name="fal fa-ban" />
                    {{ calculatePercentage(qty_user_sale_failed) }}% {{ $t('reproved') }}
                </span>

                <span class="text-warning capitalize text-weight-bold q-mr-md">
                    <q-icon name="fal fa-exclamation-triangle" />
                    {{ calculatePercentage(qty_user_sale_unaudited) }}% {{ $t('unaudited') }}
                </span>

                <q-btn color="positive" icon="fal fa-plus" :label="$t('insert_user_sale')" @click="showInsertSale()" v-if="$route.name !== 'reward_order' && showButtonsEdit" />
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props" :props="props">
                <q-td auto-width key="order_number" :props="props">
                    {{ props.row.order_number }}
                </q-td>

                <q-td key="company" :props="props">
                    {{ props.row.company }}
                </q-td>

                <q-td key="branch" :props="props">
                    {{ props.row.branch }}
                </q-td>

                <q-td key="created_date" :props="props">
                    {{ fDate(props.row.created_date) }}
                </q-td>

                <q-td key="sale_date" :props="props">
                    {{ props.row.sale_date }}
                </q-td>

                <q-td key="total_points" :props="props">
                    {{ props.row.total_points ? Math.round(props.row.total_points*100)/100 : 0 }}
                </q-td>

                <q-td key="status" :props="props" auto-width >
                    <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)" >
                        {{ $t(getStatus(props.row.status)) }}
                    </q-chip>
                </q-td>

                <q-td key="actions" :props="props">
                    <q-btn flat round color="primary" icon="far fa-hourglass" @click="openModalHistory(props.row.actions)" />
                    <q-btn flat round color="primary" icon="far fa-list-alt" @click="openModalProducts(props.row.actions)" />
                </q-td>
            </q-tr>
        </q-table>

        <q-modal v-model="show_products" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '90vh'}" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="clouseModalProducts()" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ transaction.user_email }} - {{ transaction.order_number }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class=" q-mb-md row justify-between items-center">
                        <span class="q-display-1 q-headline text-weight-light">{{ $t('sale_information') }}</span>
                    </div>

                    <div class="col-xs-12 col-sm-12">
                        <div class="row gutter-xs">
                            <div class="col-4">
                                <q-input v-model="transaction.order_number" :float-label="$t('order_number')" disable />
                            </div>

                            <div class="col-4">
                                <q-input v-model="transaction.company" :float-label="$t('company')" disable />
                            </div>

                            <div class="col-4">
                                <q-input v-model="transaction.branch" :float-label="$t('branch')" disable />
                            </div>
                        </div>
                        <div class="row gutter-xs">
                            <div class="col-6">
                                <q-input v-model="transaction.sale_date" :float-label="$t('sale_date')" disable />
                            </div>

                            <div class="col-6">
                                <q-input v-model="transaction.total_points" :float-label="$t('total_points')" disable />
                            </div>
                        </div>
                    </div>

                    <div class="row gutter-sm justify-end q-mt-lg">
                        <div class="col-xs-12 col-sm-3">
                            <q-btn color="primary" class="full-width" :label="`${$t('images')} (${images.length})`" icon="fal fa-eye" @click="openImage()" :disable="images.length == 0 ? true : false"/>
                        </div>
                    </div>

                     <div class="q-display-1 q-mb-md">
                        <span class=" q-headline text-weight-light">{{ $t('products') }}</span>
                    </div>

                    <q-table
                        :data="products"
                        :columns="columns_products"
                        :filter="filter"
                        :pagination.sync="history_pagination"
                        row-key="name"
                        :no-data-label="$t('no_data_avaliable')"
                        :no-results-label="$t('no_results_found')"
                        :loading-label="$t('loading_data')"
                        :rows-per-page-label="$t('items_per_page')"
                        :rows-per-page-options="[0]"
                        binary-state-sort
                        :hide-bottom="true"
                        class="q-mt-md"
                        >
                        <q-tr slot="header" slot-scope="props" :props="props">
                            <q-th v-for="col in props.cols" :key="col.name" :props="props">
                            {{ $t(col.label) }}
                            </q-th>
                        </q-tr>

                        <q-tr slot="body" slot-scope="props" :props="props">
                            <q-td auto-width key="product_code" :props="props">
                                {{ props.row.product_code }}
                            </q-td>

                            <q-td auto-width key="product" :props="props">
                                {{ props.row.product }}
                            </q-td>

                            <q-td auto-width key="product_type" :props="props">
                                {{ props.row.product_type }}
                            </q-td>

                            <q-td auto-width key="brand" :props="props">
                                {{ props.row.brand }}
                            </q-td>

                            <q-td auto-width key="quantity" :props="props">
                                <q-btn color="primary" text-color="white" :label="props.row.quantity" no-ripple />
                            </q-td>

                            <q-td  auto-width key="points" :props="props">
                                <q-btn color="primary" text-color="white" :label="getQuantity(props.row.points)" no-ripple>
                                    <q-tooltip>
                                        <p>{{$t('unit_points_brand')}}: {{ props.row.points.unit_points_brand}}</p>
                                        <p>{{$t('unit_points_product_type')}}: {{ props.row.points.unit_points_product_type}}</p>
                                        <p>{{$t('unit_points_product')}}: {{ props.row.points.unit_points_product}}</p>
                                    </q-tooltip>
                                </q-btn>
                            </q-td>

                            <q-td auto-width key="sale_total_points" :props="props">
                                <q-btn color="primary" text-color="white" :label="props.row.sale_total_points" no-ripple />
                            </q-td>
                        </q-tr>

                    </q-table>

                    <div class="row gutter-sm justify-end q-mt-lg">
                        <div class="col-xs-12 col-sm-3" v-if="showButtonsEdit">
                            <q-btn color="negative" class="full-width" :label="$t('reprove')" icon="far fa-times" @click="show_confirm_reprove_sale = true" />
                        </div>

                        <div class="col-xs-12 col-sm-3" v-if="showButtonsEdit">
                            <q-btn color="positive" class="full-width" :label="$t('approve')" icon="far fa-check-double" @click="setStatus(4)" />
                        </div>

                        <div class="col-xs-12 col-sm-3">
                            <q-btn color="tertiary" class="full-width" :label="$t('close')" icon="far fa-ban" @click="clouseModalProducts()" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>

        <q-modal v-model="show_images" maximized no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <div class="layout-padding">
                    <q-carousel
                        arrows
                        ref="carousel"
                        class="full-height"
                        color= "white"

                    >
                        <q-carousel-slide class="text-center" v-for="(img, index) in images" :key="index">
                            <v-zoomer :style="classZoomer" pivot='cursor' :limitTranslation="false">
                                <img :style="classRotate" :src="img" style="max-height: 80vh;">
                            </v-zoomer>
                        </q-carousel-slide>

                        <q-carousel-control slot="control-button"  position="top-right">
                            <q-btn
                            round dense
                            icon="far fa-times"
                            @click="fullscreen()"
                            />
                        </q-carousel-control>
                        <q-carousel-control slot="control-nav"  position="bottom-right">
                            <q-btn
                                round dense
                                icon="far fa-undo"
                                @click="rotate('-')"
                            />
                            <q-btn
                                round dense
                                icon="far fa-redo-alt"
                                @click="rotate('+')"
                            />
                        </q-carousel-control>

                    </q-carousel>
                </div>
            </q-modal-layout>
        </q-modal>

        <q-dialog v-model="show_confirm_remove_sale">
            <span slot="title">{{ $t('delete_sale') }}</span>

            <span slot="message">{{ $t('do_you_really_want_to_delete_the_sale_this_action_cannot_be_undone') }}</span>

            <template slot="buttons" slot-scope="props">
                <q-btn color="primary" :label="$t('cancel')" @click="show_confirm_remove_sale = false" />
                <q-btn color="negative" :label="$t('remove')" @click="removeSale()" />
            </template>
        </q-dialog>

        <q-dialog v-model="show_confirm_reprove_sale">
            <span slot="title">{{ $t('reprove_sale') }}</span>

            <span slot="message">{{ $t('inform_the_reason_for_the_disapproval_of_the_sale') }}</span>

            <div slot="body">
                <div class="row q-gutter-sm">
                    <div class="col-12">
                        <q-select v-model="justification" :options="reward_audit_sell_justifications" :float-label="$t('justification')" />
                    </div>

                    <div class="col-12">
                        <q-input v-model="observation" :float-label="$t('observation')" />
                    </div>
                </div>
            </div>

            <template slot="buttons" slot-scope="props">
                <q-btn color="primary" :label="$t('cancel')" @click="show_confirm_reprove_sale = false" />
                <q-btn color="negative" :label="$t('reprove')" @click="setStatus(2)" :disable="!justification" />
            </template>
        </q-dialog>

        <q-modal v-model="show_audit_history" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '90vh'}" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_audit_history = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('audit_history') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <q-table
                        :data="audit_history"
                        :columns="columns_audit_history"
                        :pagination.sync="server_pagination_audit_history"
                        row-key="audited_date"
                        :no-data-label="$t('no_data_avaliable')"
                        :no-results-label="$t('no_results_found')"
                        :loading-label="$t('loading_data')"
                        :rows-per-page-label="$t('items_per_page')"
                        :rows-per-page-options="[0]"
                        binary-state-sort
                        >
                        <q-tr slot="header" slot-scope="props" :props="props">
                            <q-th v-for="col in props.cols" :key="col.name" :props="props">
                            {{ $t(col.label) }}
                            </q-th>
                        </q-tr>

                        <q-tr slot="body" slot-scope="props" :props="props">
                            <q-td auto-width key="from_status" :props="props">
                                <q-chip small :icon="getIconStatus(props.row.from_status)" :color="getColorStatus(props.row.from_status)" >
                                    {{ $t(getStatus(props.row.from_status)) }}
                                </q-chip>
                            </q-td>

                            <q-td key="to_status" :props="props">
                                <q-chip small :icon="getIconStatus(props.row.to_status)" :color="getColorStatus(props.row.to_status)" >
                                    {{ $t(getStatus(props.row.to_status)) }}
                                </q-chip>
                            </q-td>

                            <q-td key="audited_date" :props="props">
                                {{ fDateTime(props.row.audited_date) }}
                            </q-td>

                            <q-td key="user_audited" :props="props">
                                {{ props.row.user_audited }}
                            </q-td>

                            <q-td key="justification" :props="props">
                                {{ props.row.justification }}
                            </q-td>

                            <q-td key="observation" :props="props">
                                {{ props.row.observation }}
                            </q-td>
                        </q-tr>
                    </q-table>
                </div>
            </q-modal-layout>
        </q-modal>

        <insert-sale v-if="$route.name !== 'reward_order'" />
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { date, debounce } from 'quasar'
const { formatDate } = date
import * as moment from 'moment'
import * as tz from 'moment-timezone'
import InsertSale from 'components/admin/redeems/InsertSale.vue'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "profile", "training", "admin", "rewards" ] },

    props: ['user_id'],

    data() {
        return {
            id_redeem: '',
            degrees:0,
            historys: [],
            loading: false,
            filter: '',
            show_products: false,
            products:[],
            images:[],
            transaction: {
                order_number: '',
                sale_date: '',
                created_date: '',
                total_points: '',
                status: '',
                total_user_points: '',
                user_email:'',
                user_full_name: '',
                company: '',
                branch: '',
            },
            columns_history: [
                {
                    name: 'order_number',
                    required: true,
                    label: 'order_number',
                    align: 'left',
                    field: 'order_number',
                    sortable: true,
                },
                {
                    name: 'company',
                    required: true,
                    label: 'company',
                    align: 'left',
                    field: 'company',
                    sortable: true,
                },
                {
                    name: 'branch',
                    required: true,
                    label: 'store',
                    align: 'left',
                    field: 'branch',
                    sortable: true,
                },
                {
                    name: 'created_date',
                    required: true,
                    label: 'created_date',
                    align: 'left',
                    field: 'created_date',
                    sortable: true,
                },
                {
                    name: 'sale_date',
                    required: true,
                    label: 'sale_date',
                    align: 'left',
                    field: 'sale_date',
                    sortable: true,
                },
                {
                    name: 'total_points',
                    required: true,
                    label: 'total_points',
                    align: 'left',
                    field: 'total_points',
                    sortable: true,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: true,
                },
                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'right',
                    field: 'edit',
                    sortable: false,
                },
            ],
            columns_products: [
                {
                    name: 'product_code',
                    required: true,
                    label: 'product_code',
                    align: 'left',
                    field: 'product_code',
                    sortable: true,
                },
                {
                    name: 'product',
                    required: true,
                    label: 'product',
                    align: 'left',
                    field: 'product',
                    sortable: true,
                },
                {
                    name: 'product_type',
                    required: true,
                    label: 'product_type',
                    align: 'left',
                    field: 'product_type',
                    sortable: true,
                },
                {
                    name: 'brand',
                    required: true,
                    label: 'brand',
                    align: 'left',
                    field: 'brand',
                    sortable: true,
                },
                {
                    name: 'quantity',
                    required: true,
                    label: 'quantity',
                    align: 'center',
                    field: 'quantity',
                    sortable: true,
                },
                {
                    name: 'points',
                    required: true,
                    label: 'points',
                    align: 'left',
                    field: 'points',
                    sortable: true,
                },
                {
                    name: 'sale_total_points',
                    required: true,
                    label: 'sale_total_points',
                    align: 'center',
                    field: 'sale_total_points',
                    sortable: true,
                },
            ],
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 5,
                descending: false,
                sortBy: null
            },
            history_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                descending: false,
                sortBy: null
            },
            columns_images: [
                {
                    name: 'images',
                    required: true,
                    label: 'images',
                    align: 'left',
                    field: 'images',
                    sortable: true,
                },
            ],
            columns_audit_history: [
                {
                    name: 'from_status',
                    required: true,
                    label: 'previous_status',
                    align: 'left',
                    field: 'from_status',
                    sortable: false,
                },
                {
                    name: 'to_status',
                    required: true,
                    label: 'current_status',
                    align: 'left',
                    field: 'to_status',
                    sortable: false,
                },
                {
                    name: 'audited_date',
                    required: true,
                    label: 'date',
                    align: 'left',
                    field: 'audited_date',
                    sortable: false,
                },
                {
                    name: 'user_audited',
                    required: true,
                    label: 'auditor',
                    align: 'left',
                    field: 'user_audited',
                    sortable: false,
                },
                {
                    name: 'justification',
                    required: true,
                    label: 'justification',
                    align: 'left',
                    field: 'justification',
                    sortable: false,
                },
                {
                    name: 'observation',
                    required: true,
                    label: 'observation',
                    align: 'left',
                    field: 'observation',
                    sortable: false,
                }
            ],
            server_pagination_audit_history: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                descending: false,
                sortBy: null
            },
            show_images: false,
            qty_user_sale_audited: 0,
            qty_user_sale_failed: 0,
            qty_user_sale_unaudited: 0,
            show_confirm_remove_sale: false,
            sale: {},
            show_confirm_reprove_sale: false,
            justification: null,
            observation: '',
            audit_history: [],
            show_audit_history: false
        }
    },

    components: {
        'insert-sale': InsertSale
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            areas: 'registration_lists/country_areas',
            reload_content: 'common/reload_content',
            reward_types: 'registration_lists/reward_types',
            reward_categories: 'registration_lists/reward_categories',
            reward_audit_sell_justifications: 'registration_lists/reward_audit_sell_justifications',
            id_user_language_selected: 'common/id_user_language_selected',
            num_rows: 'datatable/num_rows',
            user_id_store: 'campaigns/user_id',
			user_module_items: 'common/user_module_items',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '100vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '100vw'
        },

        classCarousel() {
            if (this.$q.platform.is.mobile) return 'width:100%; height:auto;'
            else return ''
        },

        classZoomer() {
            if (this.$q.platform.is.mobile) return 'width: 100vw; height: 100vh;'
            else return 'width: 90vw; height: 90vh;'
        },

        classRotate() {
            return `
                transform: rotate(${this.degrees}deg);
                -ms-transform: rotate(${this.degrees}deg);
                -webkit-transform: rotate(${this.degrees}deg);
            `
        },

        activeButtonsStatus() {
            if(this.transaction.status) {
                if(this.transaction.status == 1) return false
                else return true
            }
            else return true
        },

        auditedColor() {
            if (this.percentage_audited < 50) return 'negative'
            else if (this.percentage_audited < 70) return 'warning'
            else return 'positive'
        },

        showButtonsEdit() {
            if (this.user_module_items) {
				let obj = this.user_module_items.find(
					(obj) => obj.slug == 'reward_audit_sales' && obj.permission == true
				)
				if (obj) return true
			}
            return false
        }
    },

    methods: {
        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
            this.request({pagination: this.server_pagination})
        },

        request ({ pagination }) {
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "ordering": order_by
            }
            this.savePagination()
            this.loading = true

            if (!this.user_id) {
                this.$axios.get(`/admin_rewards/rewards_orders/${this.id_redeem}/list_user_sales/?${this.$qs.stringify(data)}`, this.getHeader)
                .then(response => {
                    let format = ''

                    switch(this.id_user_language_selected) {
                        case 1:
                        case 3: format = 'DD/MM/YYYY'
                        break
                        default: format = 'MM-DD-YYYY'
                        break
                    }

                    this.historys = []
                    this.server_pagination.rowsNumber = response.data.count
                    this.historys = response.data.results.map((e, index) => ({...e, actions: index, sale_date: moment(e.sale_date).tz('Etc/GMT').format(format) }))

                    this.$axios.get(`admin_rewards/users_reward_levels/${this.user_id_store}/user_sales/get_qty_user_sale_status/`, this.getHeader)
                    .then(response => {
                        this.qty_user_sale_audited = response.data.qty_user_sale_audited
                        this.qty_user_sale_failed = response.data.qty_user_sale_failed
                        this.qty_user_sale_unaudited = response.data.qty_user_sale_unaudited
                    })
                    .catch(e => {
                        console.log(e)
                    })
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    this.loading = false
                })
            }
            else {
                this.$axios.get(`/admin_rewards/users_reward_levels/${this.user_id}/user_sales/?${this.$qs.stringify(data)}`, this.getHeader)
                .then(response => {
                    let format = ''

                    switch(this.id_user_language_selected) {
                        case 1:
                        case 3: format = 'DD/MM/YYYY'
                        break
                        default: format = 'MM-DD-YYYY'
                        break
                    }

                    this.historys = []
                    this.server_pagination.rowsNumber = response.data.count
                    this.historys = response.data.results.map((e, index) => ({...e, actions: index, sale_date: moment(e.sale_date).tz('Etc/GMT').format(format)}))

                    this.$axios.get(`admin_rewards/users_reward_levels/${this.user_id_store}/user_sales/get_qty_user_sale_status/`, this.getHeader)
                    .then(response => {
                        this.qty_user_sale_audited = response.data.qty_user_sale_audited
                        this.qty_user_sale_failed = response.data.qty_user_sale_failed
                        this.qty_user_sale_unaudited = response.data.qty_user_sale_unaudited
                    })
                    .catch(e => {
                        console.log(e)
                    })
                })
                .catch(e => {

                    console.log(e)
                })
                .finally(() => {
                    this.loading = false
                })
            }
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        openModalProducts(index) {
            this.transaction = {
                branch: this.historys[index].branch,
                company:  this.historys[index].company,
                order_number: this.historys[index].order_number,
                sale_date:  this.historys[index].sale_date,
                created_date: this.historys[index].created_date,
                total_points: this.historys[index].total_points,
                status: this.historys[index].status,
                total_user_points: this.historys[index].total_user_points,
                id: this.historys[index].id,
                user_email:this.historys[index].user_email,
                user_full_name: this.historys[index].user_full_name,
            }

            this.products = this.historys[index].products.map(item => {
                return {
                    ...item ,
                    points:{
                        "unit_points_brand": item.unit_points_brand,
                        "unit_points_product_type": item.unit_points_product_type,
                        "unit_points_product": item.unit_points_product
                    }
                }
            })

            this.images = this.historys[index].images
            this.show_products = true
        },

        openModalHistory(index) {
            this.audit_history = this.historys[index].audit_history
            this.show_audit_history = true
        },

        confirmRemoveSale(sale) {
            this.show_confirm_remove_sale = true
            this.sale = sale
        },

        removeSale() {
            this.$q.loading.show()

            this.$axios.get(`/admin_rewards/user_sale/${this.sale.id}/set_sale_as_deleted/`, this.getHeader)
            .then(response => {
                this.show_confirm_remove_sale = false

                this.$q.notify({
                    message: this.$t('user_sale_deleted_successfully'),
                    type: 'positive',
                    icon: 'fal fa-save'
                })
            })
            .catch(e => {
                console.log(e)

                this.$q.notify({
                    message: this.$t('error_deleting_user_sale'),
                    type: 'positive',
                    icon: 'fal fa-save'
                })
            })
            .finally(() => {
                this.$q.loading.hide()
                this.request({pagination: this.server_pagination})
            })
        },

        clouseModalProducts() {
            this.show_products = false
            this.server_pagination = {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 5,
                descending: false,
                sortBy: null
            }
            this.loadPagination()
        },

        setStatus(type) {
            this.$q.loading.show()

            let data = {
                sale_id: this.transaction.id,
                justification_id: this.justification,
                observation: this.observation
            }

            let url = ''

            if (!this.user_id) {
                if(type == 2) url = `/admin_rewards/rewards_orders/${this.id_redeem}/set_sale_as_reproved/`
                else  url = `/admin_rewards/rewards_orders/${this.id_redeem}/set_sale_as_audited/`

                this.$axios.post(url, data, this.getHeader)
                .then(response => {

                })
                .catch(e => {
                    this.$q.notify({
                        message: this.$t('unexpected_error_try_again_later'),
                        type: 'negative',
                        icon: 'fal fa-exclamation-triangle',
                        position: 'top'
                    })
                    console.log(e)
                })
                .finally(() => {
                    this.$q.loading.hide()

                    this.clouseModalProducts()

                    this.show_confirm_reprove_sale = false
                    this.justification = null
                    this.observation = ''
                })
            }
            else {
                if (type === 2) url = `/admin_rewards/users_reward_levels/${this.id_redeem}/user_sales/${this.transaction.id}/set_sale_as_reproved/`
                else url = `/admin_rewards/users_reward_levels/${this.id_redeem}/user_sales/${this.transaction.id}/set_sale_as_audited/`

                this.$axios.post(url, data,this.getHeader)
                .then(response => {

                })
                .catch(e => {
                    this.$q.notify({
                        message: this.$t('unexpected_error_try_again_later'),
                        type: 'negative',
                        icon: 'fal fa-exclamation-triangle',
                        position: 'top'
                    })
                    console.log(e)
                })
                .finally(() => {
                    this.$q.loading.hide()

                    this.clouseModalProducts()

                    this.show_confirm_reprove_sale = false
                    this.justification = null
                    this.observation = ''
                })
            }
        },

        openImage() {
            this.show_images = true
            this.$refs.carousel.inFullscreen = true
        },

        fullscreen(){
            this.show_images = false
        },

        getStatus(status) {
            if (status == 1) return 'unaudited'
            else if (status == 2) return 'reproved'
            else if (status == 3) return 'deleted'
            else if (status == 4) return 'audited'
            else return ''
        },

        getIconStatus(status) {
            if (status == 1) return 'fal fa-user-clock'
            else if (status == 2) return 'fal fa-user-times'
            else if (status == 3) return 'fal fa-times'
            else if (status == 4) return 'fal fa-user-check'
            else return ''
        },

        getColorStatus(status) {
            if (status == 1) return 'info'
            else if (status == 2) return 'negative'
            else if (status == 3) return 'warning'
            else if (status == 4) return 'positive'
            else return ''
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY'
                    break
                    default: format = 'MM-DD-YYYY'
                    break
                }

                return date.formatDate(d, format)
            }
        },

        fDateTime(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY HH:mm:ss'
                    break
                    default: format = 'MM-DD-YYYY HH:mm:ss'
                    break
                }

                return date.formatDate(d, format)
            }
        },

        getQuantity(points) {
            return points.unit_points_brand + points.unit_points_product_type + points.unit_points_product
        },

        rotate(operation) {
            if(operation == '+' ) {
                this.degrees += 90
            }
            else {
                this.degrees -= 90
            }
        },

        showInsertSale() {
            this.$root.$emit('showInsertSale', [])
        },

        calculatePercentage(value) {
            if (this.qty_user_sale_audited || this.qty_user_sale_failed || this.qty_user_sale_unaudited) {
                return ((value / (this.qty_user_sale_audited + this.qty_user_sale_failed + this.qty_user_sale_unaudited)) * 100).toFixed(2)
            }
            else return 0
        }
    },

    created() {
        this.id_redeem = this.$route.params.id
        if(this.id_redeem) this.loadPagination()
    },

    mounted() {
		this.$root.$on('reloadItems', () => {
            this.loadPagination()
        })
	},

	beforeDestroy() {
		this.$root.$off('reloadItems')
	}
}
</script>